export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-08T16:00:39",
  lastPipeline: "6499",
  version: "0.0.0",
  sentryDsn: '',
};
